export * from './types.js';
export { mergeVectorClock, dominates } from './vector-clock.js';
export { compareLwwRows, resolveLww, versionsMatch } from './lww.js';
export {
  filterDeltas,
  getAclBlockIds,
  shouldDeliverDelta,
  type DatabaseBlockLookup,
} from './acl-filter.js';
export {
  applyChange,
  applyChanges,
  clearSyncedTables,
  buildClientChangeFromPayload,
  type SqlExecutor,
} from './apply-change.js';
